import React from "react";
import WizardWrapper from "./productWizard/WizardWrapper";

function AddNew() {
  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Add New Product</h4>
            <h6>Create a new product to listing on your store.</h6>
          </div>
        </div>

        <WizardWrapper />
      </div>
    </>
  );
}

export default AddNew;
